export default "__VITE_ASSET__DZhtfLcB__"